module.exports = __webpack_public_path__ + "static/client9-29c37bfe5bf0db4fe172e5c3320604a9.png";